import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const miningVuex = createNamespacedHelpers("mining");
const taskVuex = createNamespacedHelpers("task");
import noZoom from "./assets/js/noZoom";
noZoom();
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    ...walletVuex.mapState(["tonConnect", "isMobile", "htmlSize"]),
    ...userVuex.mapState(["userInfo", "loginInfo", "isLogin", "settingInfo"]),
    ...taskVuex.mapState(["taskInfo"]),
    route() {
      return this.$route.path;
    },
    isPhone() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      return /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent);
    }
  },
  data() {
    return {
      isRouterAlive: true,
      isBindWallet: true,
      isPreLoad: false,
      isAdmFinish: true
    };
  },
  watch: {
    "$route.path": {
      async handler(newPath, oldPath) {
        // if (newPath === "/") {
        //   this.WebApp.BackButton.isVisible && this.WebApp.BackButton.hide();
        // } else {
        //   this.WebApp.BackButton.show();
        // }
        this.clearPopFunc();
      },
      deep: true
    },
    isMobile: {
      handler(bool) {
        if (bool === null) {
          document.body.style.setProperty("--maxWidth", "100%");
          return;
        }
        // document.body.style.setProperty("--maxWidth", bool ? this.htmlSize.w + "px" :   );
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    ...walletVuex.mapActions(["getDeviceType"]),
    ...userVuex.mapActions(["initProcess", "bindWallet", "getuserInfo"]),
    ...userVuex.mapMutations(["setIsLogin"]),
    ...miningVuex.mapMutations(["setIsAutoSpeedMine"]),
    ...miningVuex.mapActions(["autoSpeedMine", "workerDoMining"]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    adapScreen() {
      const calcMaxWidth = () => {
        const radius = 768 / 1180;
        document.body.style.setProperty("--maxWidth", this.WebApp.viewportHeight * radius + "px");
        console.log("window.innerHeight", window.innerWidth / this.WebApp.viewportHeight, radius);
        if (window.innerWidth / this.WebApp.viewportHeight > radius) {
          document.body.style.setProperty("--maxWidth", this.remTran(1500) + 'rem');
        }
        this.remFnc();
      };
      calcMaxWidth();
      const throttledCalcMaxWidth = this.fmt_throttle(calcMaxWidth, 500);
      this.WebApp.onEvent("viewportChanged", e => {
        throttledCalcMaxWidth();
      });
    },
    mLoadingResult() {
      this.isPreLoad = true;
    },
    onAdmSkip() {
      this.isAdmFinish = false;
    },
    setShareText(type = "share") {
      const that = this;
      const botname = this.settingInfo.botname;
      const refCode = this.userInfo.ref_code;
      let url = "";
      const text = `
👬 Invite friends to join Paolo Maldini’s fans space!
Each friend you invite earns you rewards. If your friend invite his friends, you earn even more! 🎁⚽️`;
      if (type == "share") {
        url = `https://t.me/share/url?url=https://t.me/${botname}/app?startapp=ref_${refCode}&text=${encodeURIComponent(text)}`;
        this.WebApp.openTelegramLink(url);
      } else if (type == "copy") {
        url = `https://t.me/${botname}/app?startapp=ref_${refCode}
  ${text}`;
        this.$copyText(url).then(function (e) {
          that.$toasted.clear();
          that.$toasted.success(that.$lang("Copy Success!"));
        }, function (e) {});
      }
    }
  },
  async mounted() {
    this.adapScreen();
    this.getDeviceType();
    this.setIsLogin(false);
    await this.initProcess();
    await this.setIsLogin(true);
    _v["shareFn"] = this.setShareText;
    console.log("this.isLoginthis.isLogin", this.isLogin);
  }
};